import React, {useState} from 'react';
import { useAgreementTableContext } from './context';
import Table from '../../../../libs/uiKit/table';
import Button from "../../../../libs/uiKit/button";
import {AddIcon} from "../../../../icons/ui/Add";
import CrossModal from "../../../pages/invoice/widgets/CrossModal";
import dayjs from "dayjs";

const AgreementTableUi: React.FC = () => {
	const { head, rows, isLoading} = useAgreementTableContext();

	return <>
		<Table head={head} rows={rows} isLoading={isLoading} />
	</>;
};

export default React.memo(AgreementTableUi);
